import { jsxs as N, jsx as r } from "react/jsx-runtime";
import { c as g } from "../../index-BkL7vJ-E.js";
import { s as j } from "../../Player.module-DcPK3CRl.js";
import { VODProviderType as A } from "../../models/VODProviderType.js";
import S from "./PlayerSourceProvider.js";
import T from "./PlayerLoading.js";
import V from "./VideoPlayer.js";
import L from "./PlayerProvider.js";
const l = ({
  classname: m,
  vodType: a,
  playUrl: o,
  sendTrack: p,
  qualityValidate: t,
  coverUrl: n,
  aspectRatio: d,
  children: f,
  vodCustomUrl: i,
  playbackRates: P,
  sendUserWatch: y,
  fullscreenOnPlay: h,
  ...c
}) => /* @__PURE__ */ N(L, { children: [
  /* @__PURE__ */ r("div", { className: g(j.container, m, "hamrah-player"), children: /* @__PURE__ */ r(S, { hlsUrl: o, provider: a, providerUrl: i == null ? void 0 : i[a], children: ({ hasError: v, isLoading: x, sources: e, vtt: D }) => x || !(e != null && e.length) ? /* @__PURE__ */ r(T, {}) : v ? /* @__PURE__ */ r("div", { children: "خطای در دریافت اطلاعات از پروایدر دریافت شده است." }) : /* @__PURE__ */ r(
    V,
    {
      vtt: D,
      sources: e,
      qualityValidate: t,
      sendTrack: p,
      coverUrl: n,
      aspectRatio: d,
      playbackRates: P,
      sendUserWatch: y,
      fullscreenOnPlay: h,
      ...c
    }
  ) }) }),
  f
] });
l.displayName = "Player";
l.defaultProps = {
  vodType: A.STANDARD
};
export {
  l as default
};
